import axios from '../../../services/axios.service';
import { getEndpointBase } from '../../../services/api.service';
import { PersonLinkEditState } from './PersonLink.type';

let listTypesRequest: any = null;
let updatesRequest: any = null;

const personLinkService = {
  getTypes: () => {
    listTypesRequest && listTypesRequest.cancel();
    listTypesRequest = axios.CancelToken.source();
    return axios.get(getEndpointBase(`people/links/types`), {
      cancelToken: listTypesRequest.token,
    });
  },
  sync: (personId: number | string, links: PersonLinkEditState[]) => {
    updatesRequest && updatesRequest.cancel();
    updatesRequest = axios.CancelToken.source();
    return axios.put(
      getEndpointBase(`people/${personId}/links/sync`),
      { links },
      {
        cancelToken: updatesRequest.token,
      },
    );
  },
};

export default personLinkService;
